<script lang="ts">
  interface Props {
    course_progress: CourseProgressType
  }

  let { course_progress }: Props = $props()
</script>

{#if course_progress.substep === 1}
  <p class="text-center text-3xl text-bold">Module 7: Annual Goals</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      Annual goals are what you and the team will focus on and accomplish in the
      next year on your way to your Long-Term Goals. I recommend you read
      chapter 6 of the book "Setting Annual and Quarterly Goals" which is
      provided in the Download Assets area. I also recommend your use the Blue
      Sky Vision Table and fill in the Annual Goals column which is column C.
    </p>

    <p class="mt-6 text-lg">
      By going through this module, you will better understand what Annual Goals
      are, why they are Important, and the steps you need to follow to create
      your own. I take you through the Flint Inc. example and then you "Do The
      Work" and set your own Annual Goals which you will enter online into your
      One Page Alignment Plan.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284832436"
        class="absolute inset-0 w-full h-full"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 2}
  <p class="text-center text-2xl font-bold">7.2 What are they?</p>

  <div class="px-12">
    <p class="mt-6 text-lg">I share with you the definition of Annual Goals.</p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284832445"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 3}
  <p class="text-center text-2xl font-bold">7.3 Why are they Important?</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      I walk you through why Annual Goals are important for you, your team, and
      your company.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284832454"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 4}
  <p class="text-center text-2xl font-bold">7.4 How to Create</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      I walk you through how to create five to seven annual goals using the Blue
      Sky Vision table that already has columns A, D, and E filled in.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284832459"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 5}
  <p class="text-center text-2xl font-bold">7.5 Flint Inc.</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      I share with you how the President of Flint Inc. followed the process to
      develop a set of Annual goals for his company.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284832490"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 6}
  <p class="text-center text-2xl font-bold">7.6 Do the Work</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      This video is a brief overview of the process you will follow to develop a
      set of Annual goals.
    </p>

    <p class="mt-6 text-lg">You Can Do This!!</p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284832496"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 7}
  <p class="text-center text-2xl font-bold">7.7 Wrap Up</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      In this video, I ask you to reflect upon the Annual Goals module. I end
      the video by giving you a brief overview of the Quarterly Goals module
      which is next.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284832503"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{/if}
